import React, { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import moment from 'moment';
import axios from 'axios';
import Button from '../../_common/Form/Buttons/Button';
import classes from './reports.module.scss';
import { RangeDatePicker } from '../../_common/Form/DatePickers/RangeDatePicker/RangeDatePicker';
import apiConfig from '../../../config';
import accountHelpers from '../../../utils/accountHelpers';

const { API_URL } = apiConfig;

const reports = [
  {
    title: 'OptumRx Shipping Accuracy Report',
    link: `${API_URL}/api/dashboards/report/optum`,
  },

  {
    title: 'URAC Turn Around Time Report',
    link: `${API_URL}/api/dashboards/report/urac`,
  },

  {
    title: 'Genentech Report',
    link: `${API_URL}/api/dashboards/report/genentech`,
  },

  {
    title: 'Prescription Export Report',
    link: `${API_URL}/api/dashboards/report/prescription`,
  },

  {
    title: 'Prime Therapeutics Report',
    link: `${API_URL}/api/dashboards/report/prime`,
  },
];

const Reports = () => {
  const [date, setDate] = useState({
    start: '',
    end: '',
  });

  const { start, end } = date;

  const onChangeDate = useCallback((currentDate) => {
    setDate({ start: currentDate[0], end: currentDate[1] });
  }, []);

  const download = useCallback((link, type) => {
    if (!start) {
      toast.error('Please choose date');
    } else {
      const tomorrow = moment().add(1, 'day').format('YYYY-MM-DD');

      axios(`${link}?start=${start}&end=${end || tomorrow}&email=${accountHelpers.getUser().email}`);

      toast.success(`${type} will be generated in background and will be sent you via email`);
    }
  }, [date]);

  return (
    <div className={classes.wrapper}>
      <div className={classes.calendar_wrapper}>
        <div className={classes.title}>Select date range</div>

        <RangeDatePicker
          currentDate={date}
          onChangeDate={onChangeDate}
        />
      </div>

      <div className={classes.report_download_wrapper}>
        {reports.map(({ title, link }) => (
          <div key={title}>
            <div className={classes.title}>{title}</div>

            <Button
              downloadButton
              reverseColor
              title="Download"
              onClick={() => download(link, title)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Reports;
